export default __webpack_public_path__ + "static/media/twitter.486cbc6e.svg";